import { Component, OnInit } from "@angular/core";

import { Meta, Title } from "@angular/platform-browser";
import { ActivatedRoute, Params } from "@angular/router";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: "app-career",
  templateUrl: "./career.component.html",
  styleUrls: ["./career.component.css"],
})
export class CareerComponent implements OnInit {
  id: any;

  displayJavaTab: boolean = false;
  displayITSMTab: boolean = true;
  displaytruesightTab: boolean = false;
  displaydiscoveryTab: boolean = false;
  displayMainframeTab: boolean = false;
  displayIonicTab: boolean = false;
  displayFrontendTab: boolean = false
  displayManagerTab: boolean = false

  title = "ITARIUM Technologies India Pvt. Ltd. | Careers";
  postingDate: string;
  configuration: any;
  constructor(
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private meta: Meta,
  ) { }

  ngOnInit() {

    var mydate = new Date();

    mydate.setDate(mydate.getDate() - 4);

    var month = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
    ][mydate.getMonth()];

    this.postingDate = mydate.getDate() + "-" + month + "-" + mydate.getFullYear();

    window.scrollTo(0, 0);
    this.activatedRoute.paramMap.subscribe((params: Params) => {
      this.id = params.get("id");
      this.displayJavaTab = false;
      this.displayITSMTab = false;
      this.displaytruesightTab = false;
      this.displaydiscoveryTab = false;
      this.displayIonicTab = false;
      this.displayMainframeTab = false;
      this.displayManagerTab = false;
      this.displayFrontendTab = false;

      console.log("ID", this.id);
      if (this.id === "Java") {
        this.displayJavaTab = true;
        this.selectedTab = " - Java";
      } else if (this.id === "ITSM") {
        this.displayITSMTab = true;
        this.selectedTab = " - BMC ITSM Implementation Engineer"
      } else if (this.id === "Consultant") {
        this.displaytruesightTab = true;
        this.selectedTab = " - BMC TrueSight Consultant"
      } else if (this.id === "Discovery") {
        this.displaydiscoveryTab = true;
        this.selectedTab = " - BMC Discovery"
      } else if (this.id === "Ionic") {
        this.displayIonicTab = true;
        this.selectedTab = " - Ionic";
      } else if (this.id === "Mainframe") {
        this.displayMainframeTab = true;
        this.selectedTab = " - Mainframe";
      } else if (this.id === "Manager") {
        this.displayManagerTab = true;
        this.selectedTab = " - Manager";
      } else if (this.id === "Frontend") {
        this.displayFrontendTab = true;
        this.selectedTab = " - UI/ Frontend Developer with (Angular experience)";
      }
      this.setMetaData(this.id)
    });
  }

  activeTab = "";
  selectedTab = "";

  setMetaData(subTitle) {
    this.activeTab = ''
    this.activeTab = subTitle;
    this.scroll()
    if (subTitle === "Java") {
      this.selectedTab = " - Java";
    } else if (subTitle === "ITSM") {
      this.selectedTab = " - BMC ITSM Implementation Engineer"
    } else if (subTitle === "Consultant") {
      this.selectedTab = " - BMC TrueSight Consultant"
    } else if (subTitle === "Discovery") {
      this.selectedTab = " - BMC Discovery"
    } else if (subTitle === "Ionic") {
      this.selectedTab = " - Ionic";
    } else if (subTitle === "Mainframe") {
      this.selectedTab = " - Mainframe";
    } else if (subTitle === "Manager") {
      this.selectedTab = " - Manager";
    } else if (subTitle === "Frontend") {
      this.selectedTab = " - UI/ Frontend Developer with (Angular experience)";
    }

    this.title = `ITARIUM Technologies India Pvt. Ltd. | Careers  ${this.selectedTab}`;

    this.titleService.setTitle(this.title);
    this.meta.addTags([
      {
        name: "keywords",
        content: "BMC, BMC Softwares, BMC Tools, Itarium Technologies, Java Developer, BMC ITSM Implementation Engineer, BMC TrueSight Consultant, BMC Discovery, Job",
      },
      {
        name: "description",
        content: "We continually invest in building deep technical expertise in BMC Software’s wide range of solutions developing strong BMC professional services consultants and today we provide the widest range of experienced consultants for BMC solutions in India.",
      },
      { name: "robots", content: "index, follow" },
    ]);
  }

  scroll() {
    window.scrollTo(100, 170);
  }
}
